import React from 'react'
import BarChart, { BarChartData } from './Bar'
import LineChart, { LineChartData } from './Line'
import PieChart, { PieChartData } from './Pie'
import { Container } from './styles'

interface ChartContainerProps {
  type: string
  data: LineChartData | PieChartData
}

const getFillByKey = (key: any): string => {
  if (key === 'Imóveis')
    return '#8884d8'
  if (key === 'Usuários')
    return '#82ca9d'
  return ''
}

const Chart: React.FC<ChartContainerProps> = ({
  data,
  type,
}) => (
    <Container>
      {type === 'line' && (
        <LineChart
          width={400}
          height={200}
          data={data as LineChartData}
        />
      )}
      {type === 'pie' && (
        <PieChart
          width={400}
          height={200}
          data={data as PieChartData}
        />
      )}
      {type === 'bar' && (
        <BarChart
          getFillByKey={getFillByKey}
          width={400}
          height={200}
          data={data as BarChartData}
        />
      )}
    </Container>
  )

export default Chart
